import { Injectable } from "@angular/core";
import { User } from "src/app/shared/models";
import { firstValueFrom } from "rxjs";
import { Router } from "@angular/router";
import { UserService } from "../../http/user.service";
import { UserRole } from "src/app/shared/models/user-role";

@Injectable({
  providedIn: "root",
})
export class CoordinatorService {
  userProfile: User;

  constructor(private userService: UserService, private router: Router) {}

  onInit() {
    this.userProfile = JSON.parse(sessionStorage.getItem("profile-ell"));
  }

  async getManagersByBu(bu) {
    let res = await firstValueFrom(
      this.userService.getUserByFilters(bu, UserRole.MGR)
    );
    return res;
  }

  async getTechAprsByBu(bu) {
    let res = await firstValueFrom(
      this.userService.getUserByFilters(bu, UserRole.TECHAPR)
    );
    return res;
  }

  async getEcApproversByBu(bu) {
    let res = await firstValueFrom(
      this.userService.getUserByFilters(bu, UserRole.ECAPR)
    );
    return res;
  }

  async getLegalApproversByBu(bu) {
    let res = await firstValueFrom(
      this.userService.getUserByFilters(bu, UserRole.LGAPR)
    );
    return res;
  }
}
